


























import { Component } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { LendingAccountModule } from '@/store/Accounts/LendingAccountModule';
import Schedule from '@/components/Accounts/LendingAccounts/Schedules/Schedule.vue';

@Component({ name: 'ScheduleSubTabs', components: { Schedule } })
export default class extends SaascadaVue {

    tabIndex = 0;

    get simulationModeEnabled() {
        return LendingAccountModule.simulationModeEnabled;
    }

    get scheduleInstallments() {
        return LendingAccountModule.schedule.schedule;
    }

    get simulatedScheduleInstallments() {
        return LendingAccountModule.simulation.loanSchedule;
    }

    get totalSchedulesPages() {
        return LendingAccountModule.totalSchedulePages;
    }

    get totalSimulatedSchedulesPages() {
        // Calculate the total pages for the simulated schedule manually here as we aren't storing it in the module
        const totalScheduleInstallments = LendingAccountModule.simulation.loanSchedule?.length;
        return Math.ceil(totalScheduleInstallments/LendingAccountModule.pageSize);
    }

}
